import styled, { css } from 'styled-components';
import { formatDate, decodeHtmlCharCodes } from 'utils';
import Avatar from './Avatar';
import { Media, MediaImage, MediaBody, size, spacing } from 'ui';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { capitalize } from '@tymate/sergic';

const Timestamp = styled.time`
  display: block;
  color: ${({ theme }) => theme.textLight};
  font-size: ${size(-1)};
`;

const Author = styled.div`
  display: block;
  font-size: ${size(1)};
  font-weight: 600;
  padding: 0 0 ${spacing(0.25)};

  ${props =>
    props.small &&
    css`
      font-size: ${size(0)};
    `};
`;

/**
 * Component containing Avatar on the left-hand side,
 * name and timestamp on the right-hand side.
 */
const AuthorTime = ({
  author,
  timestamp,
  label,
  hideName,
  small,
  medium,
  timestampIsActuallyNotATimestampSorryFolks,
  isUpdateTimestamp
}) => {
  const { t } = useTranslation('jobSlang');

  return (
    <Media>
      <MediaImage>
        <Avatar {...author} small={small} medium={medium} />
      </MediaImage>
      <MediaBody style={{ paddingLeft: 8 }}>
        {hideName ? (
          <Author small={small}>{label}</Author>
        ) : (
          <Author small={small}>
            {decodeHtmlCharCodes(capitalize(get(author, 'displayName')))}
            {label}
          </Author>
        )}
        {Boolean(timestamp) && !timestampIsActuallyNotATimestampSorryFolks && (
          <Timestamp>
            { isUpdateTimestamp ? t('date:updated') : t('date:on')} {formatDate(timestamp, 'd MMM yyyy')},{' '}
            {formatDate(timestamp, "HH'h'mm")}
          </Timestamp>
        )}
        {Boolean(timestamp) && timestampIsActuallyNotATimestampSorryFolks && (
          <Timestamp>{t(get(author, 'topPlaceRole'))}</Timestamp>
        )}
      </MediaBody>
    </Media>
  );
};

AuthorTime.defaultProps = {
  author: {},
};

export default AuthorTime;
